import {isFeatureEnabled} from 'feature-flags';

import {yupNumber} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {featureFlags} from '../../../utils/featureFlags';

const POWER_MIN = 10;
const POWER_MAX = 650;

export function buildPowerValidation(allowedPowerValues: number[]) {
  const base = yupNumber
    .integer(i18n.t('page.create.validation.powerMustBeInteger'))
    .min(POWER_MIN, ({min}) => i18n.t('page.create.validation.powerMustBeMin', {min}))
    .max(POWER_MAX, ({max}) => i18n.t('page.create.validation.powerMustBeMax', {max}))
    .required();

  if (!isFeatureEnabled(featureFlags.PR_FORM_STATISTICS)) {
    return base;
  }

  return base.oneOf(allowedPowerValues, (params: {value?: number}) =>
    i18n.t('page.create.validation.powerMustBeOneOfOptions', {
      value: params.value ?? '',
    })
  );
}
